var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, AutomaticUpdatesIcon, Button, InfoSignIcon, LayoutHierarchyIcon, Pane, Paragraph, PrintIcon, Table, toaster, Tooltip, TrashIcon, } from "evergreen-ui";
import "firebase/firestore";
import { useContext, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import firebase from "../config";
import { PaymentContext } from "../contexts/PaymentContext";
import { useQueryState } from "../hooks/useQueryState";
import PrintingService from "../services/PrintingService";
import deleteTour from "../utility/deleteTour";
import { optimizeTour } from "../utility/optimizeTour";
import TaskListRow from "./TaskListRow";
import TourAccountingLayout from "./TourAccountingLayout";
import TourPrintLayout from "./TourPrintLayout";
export default function TaskList(props) {
    var _this = this;
    var _a;
    var _b = useState(), driver = _b[0], setDriver = _b[1];
    var _c = useState(false), optimizeLoading = _c[0], setOptimizeLoading = _c[1];
    var _d = useState(false), isLoading = _d[0], setLoading = _d[1];
    var ref = useRef();
    var accountingRef = useRef();
    //PaymentDialog
    var quotaManagementState = useContext(PaymentContext).quotaManagementState;
    var _ = quotaManagementState[0], setQuotaManagementShown = quotaManagementState[1];
    var _e = useQueryState(), __ = _e[0], setQueryData = _e[1];
    var handlePrint = useReactToPrint({
        content: function () { return ref.current; },
    });
    var _f = useState(false), loading = _f[0], setloading = _f[1];
    var _g = useState(false), renderAccountingLayout = _g[0], setRenderAccountingLayout = _g[1];
    var manuelStatusChange = function () {
        setloading(true);
        var finishTour = firebase
            .app()
            .functions("europe-west3")
            .httpsCallable("finishTour");
        finishTour({ tourId: props.tour.id })
            .then(function (result) {
            toaster.success("Statusänderung war erfolgreich!");
        })
            .catch(function (err) {
            toaster.warning("Ein Fehler ist unterlaufen");
        })
            .finally(function () { return setloading(false); });
    };
    var handlePrintAccounting = useReactToPrint({
        content: function () { return accountingRef.current; },
    });
    var reoptimize = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setOptimizeLoading(true);
            optimizeTour(props.tour)
                .then(function (result) {
                if (result.data.msg === "error: usagequota exhausted")
                    setQuotaManagementShown(true);
            })
                .catch(function () { return setOptimizeLoading(false); })
                .finally(function () { return setOptimizeLoading(false); });
            return [2 /*return*/];
        });
    }); };
    // Handler for deleting a tour
    var handleDeleteTour = function () { return __awaiter(_this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deleteTour(props.tour, setLoading, toaster)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.error("Error deleting tour:", err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        firebase
            .firestore()
            .collection("drivers")
            .doc(props.tour.driver)
            .get()
            .then(function (doc) {
            var data = doc.data();
            setDriver(data);
        });
    }, [props.tour.driver]);
    return (_jsxs(_Fragment, { children: [((_a = props.tour) === null || _a === void 0 ? void 0 : _a.prevTour) && (_jsx(Alert, { intent: "warning", title: "Diese Tour wurde automatisch beendet, da eine Neuoptimierung w\u00E4hrend der Fahrt statt fand", marginBottom: 16, onClick: function () {
                    var _a;
                    props.setModalShown(false);
                    setQueryData({ tourId: (_a = props.tour) === null || _a === void 0 ? void 0 : _a.prevTour });
                    window.location.reload();
                } })), _jsxs(Pane, __assign({ style: { width: "95%" } }, { children: [_jsx(Button, __assign({ onClick: handlePrint, iconBefore: _jsx(PrintIcon, {}) }, { children: "Tour-\u00DCbersicht drucken" })), _jsx(Button, __assign({ marginLeft: 10, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _b = (_a = console).log;
                                        return [4 /*yield*/, PrintingService.printTaskLabel(props.tour, props.task.task_origin)];
                                    case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                                }
                            });
                        }); }, iconBefore: _jsx(PrintIcon, {}) }, { children: "Tour-Label drucken" })), _jsx(Button, __assign({ marginLeft: 10, isLoading: loading, onClick: manuelStatusChange, intent: "success", iconBefore: _jsx(AutomaticUpdatesIcon, {}) }, { children: "als Beendet markieren" })), props.tour.status !== "finished" ? (_jsx(Button, __assign({ marginLeft: 10, isLoading: loading, onClick: handleDeleteTour, intent: "danger", iconBefore: _jsx(TrashIcon, {}) }, { children: "Tour l\u00F6schen" }))) : (_jsx(Button, __assign({ marginLeft: 10, onClick: function () {
                            setRenderAccountingLayout(true);
                            setTimeout(function () {
                                handlePrintAccounting();
                            }, 400);
                        } }, { children: "Tourabrechnung drucken" }))), (props.tour.tasksToAdd && props.tour.tasksToAdd.length) ||
                        (props.tour.tasksToRemove && props.tour.tasksToRemove.length) ? (_jsx(Button, __assign({ marginLeft: 10, isLoading: optimizeLoading, onClick: reoptimize, iconAfter: LayoutHierarchyIcon, intent: "success" }, { children: "Jetzt neu optimieren" }))) : null] })), _jsxs(Pane, __assign({ style: { display: "none" } }, { children: [_jsx(TourPrintLayout, { driver: driver, tour: props.tour, areTasksInTour: props.areTasksInTour, ref: ref }), renderAccountingLayout && (_jsx(TourAccountingLayout, { driver: driver, ref: accountingRef, tour: props.tour }))] })), _jsxs(Pane, __assign({ style: { width: "100%", height: "50%", padding: 10 } }, { children: [_jsx(Paragraph, __assign({ fontWeight: 600, marginTop: 5 }, { children: "Optimierte Route" })), _jsxs(Table.Head, __assign({ style: {
                            backgroundColor: "#F8FBFF",
                        } }, { children: [_jsx(Table.TextHeaderCell, { children: "Status" }), _jsx(Table.TextHeaderCell, { children: "Kunde/in" }), _jsx(Table.TextHeaderCell, { children: "Liefer- Abholort" }), _jsx(Table.TextHeaderCell, { children: "Auftrag von" }), _jsx(Table.TextHeaderCell, { children: "offener Betrag" }), _jsx(Table.TextHeaderCell, { children: "zus\u00E4tzliche Aufenthaltsdauer" }), _jsxs(Table.TextHeaderCell, __assign({ style: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    width: "100%",
                                } }, { children: ["Soll Zeit", _jsx(Tooltip, __assign({ content: "Das ist die errechnete Ankunftzeit von apomap, wenn der Fahrer p\u00FCnktlich zur angegeben Soll Startzeit losf\u00E4hrt." }, { children: _jsx(InfoSignIcon, { style: { marginLeft: 10 } }) }))] }))] })), _jsx(Pane, __assign({ style: { width: "100%", overflow: "scroll" } }, { children: props.areTasksInTour.map(function (obj, index) {
                            return (_jsx(TaskListRow, { index: index, tour: props.tour, data: obj.data, type: obj.type }));
                        }) }))] }))] }));
}
